export { default } from './product-carousel-loading-state';
